"use client";

import { useEffect, useState } from "react";
import { useLocale } from "next-intl";

export interface CurrencyPrices {
  basicPrice: string;
  premiumPrice: string;
  rebateAmount: string;
}

// EUR prices mirror de.json — single source of truth for EU users on /en.
const EUR_PRICES: CurrencyPrices = {
  basicPrice: "40 €",
  premiumPrice: "60 €",
  rebateAmount: "7 €",
};
const EUR_LOCALES = new Set(["de", "el", "es", "fi", "fr", "it", "nl", "pt"]);

/**
 * Returns EUR overrides for euro locales and when geolocation selects EUR for
 * an English-language visitor. Other locales use their translated prices.
 */
export function useCurrencyPrices(): CurrencyPrices | null {
  const locale = useLocale();
  const [prices, setPrices] = useState<CurrencyPrices | null>(null);

  useEffect(() => {
    if (EUR_LOCALES.has(locale)) {
      setPrices(EUR_PRICES);
      return;
    }

    if (locale !== "en") {
      setPrices(null);
      return;
    }

    const match = document.cookie.match(/gg-currency=([^;]+)/);
    const currency = match?.[1];
    setPrices(currency === "eur" ? EUR_PRICES : null);
  }, [locale]);

  return prices;
}
